import { createContext, useContext } from "react";
import type { FeatureFlags } from "./featureFlags";

type FeatureFlagContextType = {
  featureFlags?: FeatureFlags;
  isLoading: boolean;
  isError: boolean;
};

export const FeatureFlagContext = createContext<FeatureFlagContextType>({
  isLoading: true,
  isError: false,
});

export const useFeatureFlagContext = () => {
  const context = useContext(FeatureFlagContext);
  if (!context) {
    throw new Error(
      "useFeatureFlagContext must be used within a FeatureFlagProvider",
    );
  }
  return context;
};
